import AddressSlide from './AddressSlide';

export default AddressSlide;
